import React, { Component } from 'react';
import _ from 'lodash';
import GreyGiftSvg from '../GreyGiftSvg';

class EmptyGiftListIndicator extends Component {
  constructor(props) {
    super(props);

    const { giftList } = props;
    if (!_.isString(giftList)) throw new Error('prop giftList has to be a string');

    let state;
    switch (giftList) {
      case 'registered':
        state = {
          topMessage: 'Tu lista de regalos está vacía',
          bottomMessageFirstHalf: 'Agrega regalos a tu lista y compártela con tus invitados',
          bottomMessageSecondHalf: 'con tus invitados.',
        };
        break;
      case 'received':
        state = {
          topMessage: 'Sin regalos recibidos',
          bottomMessageFirstHalf: 'Comparte tu lista a tus invitados para recibir regalos.',
          bottomMessageSecondHalf: 'Agrega más regalos y descubre cuáles incluyen bonificación.',
        };
        break;
      case 'personalPurchases':
        state = {
          topMessage: 'Sin compras personales',
          bottomMessageFirstHalf: 'Empieza a explorar nuestros productos y realiza tu primera compra hoy',
          bottomMessageSecondHalf: 'Agrega más regalos y descubre cuáles incluyen bonificación.',
        };
        break;
      case 'registered_noSearchResults':
        state = {
          topMessage: 'Tu lista de regalos está vacía',
          bottomMessageFirstHalf: 'No hay resultados para este tipo de regalo',
          bottomMessageSecondHalf: 'Agrega más regalos y descubre cuáles incluyen bonificación.',
        };
        break;
      case 'received_noSearchResults':
        state = {
          topMessage: 'Tu lista de regalos está vacía',
          bottomMessageFirstHalf: 'No hay resultados para este tipo de regalode regalo',
          bottomMessageSecondHalf: 'Agrega más regalos y descubre cuáles incluyen bonificación.',
        };
        break;
      case 'personalPurchases_noSearchResults':
        state = {
          topMessage: 'Tu lista de regalos está vacía',
          bottomMessageFirstHalf: 'No hay resultados para este tipo de regalo',
          bottomMessageSecondHalf: 'Agrega más regalos y descubre cuáles incluyen bonificación.',
        };
        break;
      default:
        throw new Error(`giftList ${giftList} not expected`);
    }

    this.state = state;
  }

  render() {
    const { giftList } = this.props;
    const greyGiftSvgType = giftList === 'registered' ? 'closed' : giftList === 'received' || giftList === 'personalPurchases' ? 'boxopen' : 'opened';

    return (
      <>
        <div className="row text-center" style={{ color: 'gray', fontSize: '1.4rem', ...this.props.style }}>
          {/* <div className="col-xs-12" style={{ fontSize: '1.6rem' }}>
          <b>{this.state.topMessage}</b>
        </div> */}
          {giftList == 'registered' || giftList == 'received' || giftList == 'personalPurchases' ? (
            <>
              <div className="col-xs-12 bottomMessageFirstHalf  toptext-margin">
                {this.state.topMessage}
              </div>
              <div className="col-xs-12" style={{ margin: '0' }}>
                <GreyGiftSvg type={greyGiftSvgType} width="15%" height="auto" />
              </div>
              <div className="col-xs-12 bottomMessageSecondHalf  bottomtext-margin">
                {this.state.bottomMessageFirstHalf}
              </div>
            </>
            )
            :
            (
            <>
              <div className="col-xs-12" style={{ margin: '0' }}>
                <GreyGiftSvg type={greyGiftSvgType} width="30%" height="auto" />
              </div>
              <div className="col-xs-12 bottomMessageFirstHalf">
                {this.state.bottomMessageFirstHalf}
              </div>
              <div className="col-xs-12 bottomMessageSecondHalf">
                {this.state.bottomMessageSecondHalf}
              </div>
            </>
            )
          }
        </div>
      </>
    );
  }
}

export default EmptyGiftListIndicator;
